export const TAB_HOME = 'home'
